// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__8ycfc","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2WFvl"};